import { GET_LOCALSTORAGE_JWT } from "../../config";

const initState = {
  theme: GET_LOCALSTORAGE_JWT("theme"),
};
export const themeReducer = (state = initState, action) => {
  switch (action.type) {
    case "THEME_GET":
      return { theme: action.payload };
    default:
      return state;
  }
};
